import { useCheckLogin } from '_api';
import { InitialRouteMap } from '_constants';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useNavigateTo } from 'utils';

export const LoggedInViewWrapper = () => {
  const { data: account } = useCheckLogin();
  const navigate = useNavigateTo();

  useEffect(() => {
    if (account && account.status === 'AWAITING_ACTIVATION')
      navigate(InitialRouteMap.CHANGEPASSWORD);

    let timer = setTimeout(() => {
      if (account?.id === 0 || account === undefined) {
        navigate(InitialRouteMap.LOGIN);
      }
    }, 2500);
    return () => clearTimeout(timer);
  }, [account]);

  return <Outlet />;
};
